















































































































import Vue from 'vue';
import { mapState } from 'vuex';
import Analytics from '@/mixins/analytics';
import Helpers from '@/mixins/helpers';
import Api from '@/mixins/api';
import Validation from '@/mixins/validation';
import axios from 'axios';
import FieldDropdown from '@/components/dumb/FieldDropdown.vue';
import FieldRadioButton from '@/components/dumb/FieldRadioButton.vue';
import FieldText from '@/components/dumb/FieldText.vue';
import LoadingFancy from '@/components/dumb/LoadingFancy.vue';
import TooltipInfo from '@/components/dumb/TooltipInfo.vue';
import VueRecaptcha from 'vue-recaptcha';

export default Vue.extend({
	name: 'TprForm', 
	components: {
		FieldDropdown, 
		FieldText, 
		FieldRadioButton, 
		LoadingFancy, 
		VueRecaptcha, 
		TooltipInfo
	},
	data(): any {
		return {
			isFormValid: false, 
			isProcessing: false,
			showFancyLoaderForFinishing: false,
			yesNo: [
				{value: true, label: 'Yes'},
				{value: false, label: 'No'}
			],
			states: [
				'Overseas',
				'ACT',
				'NSW',
				'NT',
				'QLD',
				'SA',
				'TAS',
				'VIC',
				'WA',
			],
			// licenseOrigins: [
			// 	'Australia', 
			// 	'Overseas'
			// ], 
			captcha: {
				error: false, 
				rendered: false
			}
		};
	},
	computed: {
		...mapState({
			app(): any { return this.$store.state.app }, 
			vehicle(): any { return this.$store.state.vehicle }, 
			dealer(): any { return this.$store.state.dealer }, 
			customer(): any { return this.$store.state.customer }, 
			openModal(): any { return this.$store.state.openModal }
		}),
		livingStatus(): any {
			return Helpers.livingStatus;
		},
		captchaErrorMessage(): string {
			if (this.captcha.error){
				return this.captcha.rendered ? 'Captcha is a required field' : 'Your browser has blocked Captcha. Please try a different browser.';
			}
			return '';
		},
		captchaSiteKey(): string {
			return this.$store.getters.captchaSiteKey;
		},
		isLicenseStateVisible(): boolean{
            return this.customer.licenseOrigin == 'Australia';
		},
		driverLicenceValidation(): Array<Function> {
			return [(v: string) => !!v && v.length >= 4 && (this.isLicenseStateVisible ? v.length < 10 : v.length < 16)];
		},
		customerLicenseOrigin: {
            get(): string {
                return this.customer.licenseOrigin;
            },
            set(v){
                this.$store.commit('setCustomer', {
                    licenseOrigin: v
                });
            }
		},
		customerLicenseNumber: {
            get(): string {
                return this.customer.licenseNumber;
            },
            set(v: string){
                this.$store.commit('setCustomer', {
                    licenseNumber: v
                });
            }
		},
		customerLicenseState: {
            get(): string {
                return this.customer.licenseState;
            },
            set(v: string){
                this.$store.commit('setCustomer', {
                    licenseState: v
                });
            }
		},
		customerLivingStatus: {
            get(): string {
                return this.customer.livingStatus;
            },
            set(v: string){
                this.$store.commit('setCustomer', {
                    livingStatus: v
                });
            }
        },
        customerOtherProperty: {
            get(): boolean {
                return this.customer.otherProperty;
            },
            set(v: boolean){
                this.$store.commit('setCustomer', {
                    otherProperty: v
                });
            }
		},
		customerPrivacyAcceptedTpr: {
            get(): boolean {
                return this.customer.privacyAcceptedTpr;
            },
            set(v: boolean){
                this.$store.commit('setCustomer', {
                    privacyAcceptedTpr: v
                });
            }
        },
	},
	methods: {
		handlePrivacyPolicyClick(e: any): void {
			e.stopPropagation();
			(window as any).open("https://www.toyota.com.au/privacy", "_blank");
		},
		handleGetMyRateClick(): void {
			const suffix = Analytics.getSuffix();
			Analytics.sendEvent({
				"event": "formSubmit",
				"formName" : "Toyota Personalised Rate Form" + suffix
			});
			Analytics.sendEvent({
				"event": "tprStage",
				"stageName" : "Submitted"
			});
			this.isProcessing = true;
			this.$store.commit('setOpenModal', {
				id: 'LoadingFancyModal'
			});
			this.postTpr();
		},
		postTpr(){
            Helpers.clog("post tpr");
            const url = Api.getTprPostURL();
            const postObject = {
                "guestInformation": {
                    "title": this.customer.title,
                    "firstName": this.customer.firstName,
                    "preferredName": this.customer.preferredName,
                    "lastName": this.customer.lastName,
                    "email": this.customer.email,
                    "telephone": this.customer.phone.replace(/\s/g,''),
                    "otherGivenName": '',
                    "dateofBirth": this.customer.dob + 'T00:00:00',
                    "currAddressOwnerShip": parseInt(this.customer.livingStatus),
                    "driversLicenceNumber": this.customer.licenseNumber,
                    "driversLicenceCountry": this.customer.licenseOrigin,
                    "driversLicenceState": this.customer.licenseOrigin == 'Overseas' ? '' : this.customer.licenseState,
                    "currSa1Code": this.customer.sa1Code, 
                    "fullAddress": this.customer.address,
                    "address": {
                        "unitNumber": this.customer.unitNo,
                        "subPremise": this.customer.subPremise,
                        "suburb": this.customer.suburb,
                        "state": this.customer.state,
                        "streetNumber": this.customer.streetNo,
                        "streetName": this.customer.streetName,
                        "streetType": this.customer.streetType,
                        "postCode": this.customer.postcode
                    }, 
                    "otherProperty": this.customer.otherProperty,
                    "dealerContactOptin": this.customer.privacyAcceptedTpr, 
                    "privacyAcknowledgement": this.customer.privacyAcceptedTpr ,
                    "bureauConsent": this.customer.privacyAcceptedTpr               
                },
                "vehicleFinanceInformation": {
                    "dealerId": this.dealer.dealerID,
                    "dealerRegion": this.dealer.region,
                    "sapDealerCode": this.dealer.sapDealerCode,
                    "dealerMetroRural": this.dealer.dealerMetroRural,
                    "vehicleBasePrice": this.vehicle.price,
                    "optionsAccessoriesTotal": 0,
                    "otherVehiclePriceSubTotal": 0,
                    "depositTotal": 0,
                    "tradeInTotal": 0,
                    "chargesTotal": 0,
                    "insuranceTotal": 0,
                    "vehicleName": this.vehicle.model,
                    "vehicleVariant": this.vehicle.fullDescription,
                    "vehicleMake": 'TOYOTA',
                    "vehicleModelYear": this.vehicle.produced.substring(0, this.vehicle.produced.indexOf('-')),
                    "vehicleMaterialCode": this.vehicle.materialCode,
                    "newOrUsedFlag": 'N'
                },
                "leadInformation": {
                    stockDealerID: this.dealer.stockDealerID,
                    dealerName: this.dealer.dealerName,
                    locationName: this.dealer.locationName, 
                    backlink: this.app.referrer || '',
                    address: this.customer.streetAddress,
                    vehicleSpecificationID: this.vehicle.vehicleSpecificationID,
                    VIN: this.vehicle.vin,
                    batchNumber: this.vehicle.batchNumber,
                    inStock: false,
                    grade: this.vehicle.grade,
                    transmission: this.vehicle.transmission,
                    paint: this.vehicle.paintName,
                    trim: this.vehicle.trimName,
                    factoryOptionDescription: this.vehicle.inclOption,
                    disclaimer: this.vehicle.disclaimer,
                    branchCode: this.dealer.branchCode, 
                    backLinkDetails: this.vehicle.backLink,
                    backLinkListing: this.vehicle.backLinkListing, 
                    storeUrl: (window as any).StoreWebsiteInfo ? (window as any).StoreWebsiteInfo.StoreUrl || '' : '', 
                    dealerClosed: this.dealer.dealerClosed,
                    onlineOrderClosed: this.dealer.onlineOrderClosed
                },
                "recaptchaResponse": this.customer.recaptcha 
            }
			Helpers.clog(postObject);
            axios({
                method: 'post',
                withCredentials: true, 
                url: url, 
                timeout: 120000,
                data: postObject
            }).then((response) => {
				Helpers.clog(response);
				this.showFancyLoaderForFinishing = true;
				this.isProcessing = false;
				this.$store.commit('resetOpenModal');
				
                if (response.data.acknowledgmentStatus === "Success"){
					Helpers.clog(response);
					response.data.pegaCase = response.data.pegaCase.replace('TPR-', '');
					
                    this.$store.commit('setTpr', response.data);
					this.$store.commit('setApp', { 
						tprFormSubmitted: true, 
						financeType: 'adjust', 
					});

					const caseId = response.data.pegaCase;
					const dateexp = new Date(response.data.validityDate);
                    const expires = "expires="+ dateexp.toString();
					const cookieData = ";" + expires + ';path=/';

					document.cookie = "tprguid=" + response.data.guestRateIdentifier + cookieData;
					document.cookie = "tprcaseid=" + caseId + cookieData;
					Helpers.clog('set cookies with ' + cookieData);
                    this.$router.push({ name: 'TprAdjust', query: this.$route.query });
				}
				else {
					this.$store.commit('setCustomer', {
						recaptcha: ""
					});
					this.$refs.recaptcha.reset();
					this.isProcessing = false;
					this.$store.commit('setError', {
						message: `There was a problem retrieving your rate. Please try again later or contact us.`
					});				
				}
            }).catch((error) => {
				Helpers.clog(error);
				this.$store.commit('setCustomer', {
					recaptcha: ""
				});
				this.$refs.recaptcha.reset();
				this.isProcessing = false;
				this.$store.commit('resetOpenModal');
                this.$store.commit('setError', {
                    message: `There was a problem retrieving your rate. Please try again later or contact us. `
                });             
            })
        },
		handleFieldUpdate(fieldText: string, name: string, val: any): void {
			Helpers.clog(fieldText); 
			Helpers.clog(val); 
			const suffix = Analytics.getSuffix();
			Analytics.sendEvent({
				"event": "formInteraction",
				"formName" : "Toyota Personalised Rate Form" + suffix,
				"fieldName" : fieldText,
				"fieldStatus" : "Edited"
			});
			if ('licenceState' == name){
				this.$store.commit('setCustomer', {
					licenseOrigin: (val == 'Overseas') ? 'Overseas' : 'Australia'
				});
			}
		}, 
		handleCaptchaRendered(): void {
			this.captcha.rendered = true;
		},
		setCaptcha(response: string): void {
			Helpers.clog(response);
			this.$store.commit('setCustomer', {
				recaptcha: response
			});
            this.captcha.error = false;
		},
		removeCaptcha(): void {
			this.$store.commit('setCustomer', {
				recaptcha: ''
			});
            this.captcha.error = true;
		},
	}, 
	mounted(): void {
		// Analytics.sendVirtualPageView({
		// 	"event":"omnichannelCheckOutStep",
		// 	"viewName": "03-Payment Options - Start TPR"
		// });
		// Analytics.sendEvent({
		// 	"event": "tprStage",
		// 	"stageName" : "Start"
		// });
	}
});
